import { render, staticRenderFns } from "./TelPicker.vue?vue&type=template&id=20044ddc&"
import script from "./TelPicker.vue?vue&type=script&lang=js&"
export * from "./TelPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports